'use client';

import { useClearParamsPerformer } from '~features/performers/hooks/useClearParamsPerformer';
import { useEmailConfirmPerformer } from '~features/performers/hooks/useEmailConfirmPerformer';
import { createPerformer } from '~features/performers/hooks/useRunPerformersQueue';

export const Performer = createPerformer([
	useClearParamsPerformer,
	useEmailConfirmPerformer,
]);
